<template>
    <v-dialog v-model="dialogViewer" max-width="1000px" max-height="700px" @input="close">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-img class="image-product" :lazy-src="image_url" max-height="100%" max-width="100%"
                    :src="image_url"></v-img>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
export default {
    name: "image-popup",
    data() {
        return {
            dialogViewer: false
        };
    },
    props: ["activated", "image_url"],
    watch: {
        activated: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.dialogViewer = true;
                }
            }
        }
    },
    methods: {
        close() {
            this.dialogViewer = false;
            this.$emit('update:activated', false);
        }
    }
}
</script>